import {axios} from "../../config/axios";

export const rewardAPI = {
  getReward(rewardId) {
    return axios.get(`/api/v3/rewards/${rewardId}`).then((resp) => resp);
  },
  deleteReward(rewardId) {
    return axios.delete(`/api/v3/rewards/${rewardId}`).then((resp) => resp);
  },
  patchReward(rewardId, params) {
    return axios.patch(`/api/v3/rewards/${rewardId}`, params).then((resp) => resp);
  }
}
